/*
 * Protected video — pairs with snippets/protected-video.liquid.
 * Clips always play: muted, looped, no controls. The source is attached when a
 * clip nears the viewport, and playback pauses off screen or in a hidden tab
 * (invisible to the viewer, saves bandwidth and battery). Casual save routes
 * (context menu, drag, long-press) are blocked.
 */
(function () {
  if (window.__trochiProtectedVideo) return;
  window.__trochiProtectedVideo = true;

  var probe = document.createElement('video');
  var nativeHls = !!probe.canPlayType('application/vnd.apple.mpegurl');

  function attach(video) {
    if (video.dataset.pvLoaded) return;
    var src = (nativeHls && video.dataset.hls) || video.dataset.mp4 || video.dataset.hls;
    if (!src) return;
    video.src = src;
    video.dataset.pvLoaded = '1';
  }

  function play(video) {
    attach(video);
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function block(e) { e.preventDefault(); }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var wrap = entry.target;
      var video = wrap.querySelector('video');
      wrap.dataset.pvVisible = entry.isIntersecting ? '1' : '0';
      if (entry.isIntersecting) play(video);
      else if (!video.paused) video.pause();
    });
  }, { rootMargin: '150px 0px', threshold: 0.15 });

  function init(wrap) {
    if (wrap.dataset.pvReady) return;
    wrap.dataset.pvReady = '1';
    var video = wrap.querySelector('video');
    video.muted = true;
    video.setAttribute('draggable', 'false');
    wrap.addEventListener('contextmenu', block);
    wrap.addEventListener('dragstart', block);
    if (wrap.hasAttribute('data-eager')) attach(video);
    observer.observe(wrap);
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-protected-video]').forEach(init);
  }

  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('[data-protected-video][data-pv-visible="1"]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (document.hidden) video.pause();
      else play(video);
    });
  });

  // Theme editor: re-scan sections as they are added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
})();
